export default "__VITE_ASSET__ZGXjN3B0__"